import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Login";
import AdminRedirect from "./Pages/AdminRedirect";
import ErrorPage from "./Pages/ErrorPage";
import SingleLine from "./Pages/SingleLine";
import FillInTheBlanks from "./Pages/FillInTheBlanks";
import SideBar from "./Pages/Sidebar";
import TrueFalse from "./Pages/TrueFalse";
import MultipleChoice from "./Pages/MultipleChoice";
import StudentDashboard from "./Pages/StudentDashboard";
import StudentSidebar from "./Pages/StudentSidebar";
import StudentQuizzes from "./Pages/StudentQuizzes";
import StudentResults from "./Pages/StudentResults";
import StudentPracticePage from "./Pages/StudentPracticePage";
import QuizCreationPage from "./Pages/QuizCreationPage";
import ControlPanel from "./Pages/ControlPanel";
import AdminProfile from "./Pages/AdminProfile";
import StudentProfile from "./Pages/StudentProfile";
import { IdleTimerProvider } from "./utils/IdleTimerProvider";
import { TokenExpiryProvider } from "./utils/TokenExpiryProvider";
import QuizInstructionPage from "./Pages/QuizInstructionPage";
import { CustomThemeProvider } from "./context/ThemeContext";

const LoginWrapper = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const clientCode = searchParams.get('client-code');
  if (clientCode) {
    sessionStorage.setItem('clientCode', clientCode);
  }
  return <Login />;
};

// This component conditionally wraps children with the providers
function ConditionalProviders({ children, publicPaths = ['/login'] }) {
  const location = useLocation();
  // you can expand publicPaths with '/register', '/forgot-password', etc.
  const isPublic = publicPaths.includes(location.pathname);
  if (isPublic) {
    // Don't mount IdleTimer or TokenExpiry on public pages
    return children;
  }
  return (
    <IdleTimerProvider timeoutMinutes={60/* or whatever */}>
      <TokenExpiryProvider>{children}</TokenExpiryProvider>
    </IdleTimerProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/admin-redirect" element={<AdminRedirect />} />
      <Route path="/error" element={<ErrorPage />} />

      <Route path="/dashboard" element={<SideBar><Dashboard /></SideBar>} />
      <Route path="/single-line/:id" element={<SideBar showRightToolbar={true}><SingleLine /></SideBar>} />
      <Route path="/fill-in-the-blanks/:id" element={<SideBar showRightToolbar={true}><FillInTheBlanks /></SideBar>} />
      <Route path="/true-false/:id" element={<SideBar showRightToolbar={true}><TrueFalse /></SideBar>} />
      <Route path="/quiz-creation" element={<SideBar showRightToolbar={false}><QuizCreationPage /></SideBar>} />
      <Route path="/admin-profile" element={<SideBar showRightToolbar={false}><AdminProfile /></SideBar>} />
      <Route path="/student-profile" element={<StudentSidebar showRightToolbar={false}><StudentProfile /></StudentSidebar>} />
      <Route path="/control-panel" element={<SideBar showRightToolbar={false}><ControlPanel /></SideBar>} />
      <Route path="/student-quizzes" element={<StudentSidebar><StudentQuizzes /></StudentSidebar>} />
      <Route path="/quiz/:quizId" element={<StudentPracticePage />} />
      <Route path="/quiz-instructions/:quizId" element={<QuizInstructionPage />} />
      <Route path="/multiple-choice/:id" element={<SideBar showRightToolbar={true}><MultipleChoice /></SideBar>} />
      <Route path="/student-results" element={<StudentSidebar><StudentResults /></StudentSidebar>} />
      <Route path="/student-dashboard" element={<StudentSidebar><StudentDashboard /></StudentSidebar>} />
      {/* add other protected routes here */}
    </Routes>
  );
}

function App() {
  return (
    <CustomThemeProvider>
      <Router>
        {/* Public routes — not wrapped */}
        <Routes>
          <Route path="/login" element={<LoginWrapper />} />
          {/* add other public routes (register, forgot) here */}
        </Routes>

        {/* Protected routes — conditional wrapper decides whether to mount providers */}
        <ConditionalProviders publicPaths={['/login']}>
          <AppRoutes />
        </ConditionalProviders>
      </Router>
    </CustomThemeProvider>
  );
}

export default App;
